import { cva } from 'class-variance-authority';

export const statusVariants = cva(
  ['inline-flex', 'justify-center', 'items-center'],
  {
    variants: {
      size: {
        tiny: 'gap-spacing-ref-xtiny',
        medium: 'gap-spacing-ref-xtiny',
        big: 'gap-spacing-ref-xsmall',
      },
      status: {
        neutral: 'text-color-ref-ui-status-default',
        success: 'text-color-ref-ui-status-success',
        warning: 'text-color-ref-ui-status-warning',
        danger: 'text-color-ref-ui-status-danger',
        info: 'text-color-ref-ui-status-info',
        alert: 'text-color-ref-ui-status-alert',
      },
    },
    defaultVariants: {
      size: 'medium',
      status: 'neutral',
    },
  },
);
